export default function PHP_errno() {
  return (
    <div>
      <h1>PHP_errno</h1>
    </div>
  );
}
